import styled from "styled-components";

export const MainPageDiv = styled<any>("div")`
  padding: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "16px 16px 16px 48px" : "0px"};
  gap: 16px;
  display: flex;
  width: 100%;
  margin-top: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "0px" : "0px"};
  flex-direction: column;
`;
export const HeaderMainDiv = styled<any>("div")`
  display: flex;
  align-items: center;
  padding: 16px;
`;
export const BodyMainDiv = styled<any>("div")`
  padding: 16px;
`;
export const FooterMainDiv = styled<any>("div")`
  position: fixed;
  bottom: 0px;
  display: flex;
  justify-content: center;
  width: 100%;
  background: #fff;
  z-index: 1;
  padding: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "16px 16px" : "0px"};
  width: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "50%" : "100%"};
`;
